// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  workspaceId: __t.u64(),
  roadId: __t.option(__t.u64()),
  agendaId: __t.option(__t.u64()),
  stepId: __t.option(__t.u64()),
  kind: __t.string(),
  title: __t.string(),
  bodyMd: __t.string(),
  evidenceRefsJson: __t.string(),
  authorAgentId: __t.option(__t.u64()),
  authorKind: __t.string(),
  designArchaeology: __t.bool(),
};
